
	import {
		pointInfo,
		pointList
	} from "@/api/member/my_point"
	export default {
		name: "my_point",
		components: {},
		data: () => {
			return {
				pointInfo: {
					page: 1,
					page_size: 10,
					account_type: "point"
				},
				pointList: [],
				memberPoint: {
					point: 0
				},
				total: 0,
				loading: true,
				yes: true
			}
		},
		created() {
			this.getPointInfo(), this.getpointList()
		},
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
		methods: {
			getPointInfo() {
				pointInfo({
						account_type: this.pointInfo.account_type
					})
					.then(res => {
						if (res.code == 0 && res.data) {
							this.memberPoint = res.data
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
						this.$message.error(err.message)
					})
			},
			getpointList() {
				pointList(this.pointInfo)
					.then(res => {
						if (res.code == 0 && res.data) {
							this.pointList = res.data.list
							this.total = res.data.count
							this.pointList.forEach(item => {
								item.time = this.$util.timeStampTurnTime(item.create_time)
								item.pointNum = item.account_data > 0 ? "+" + parseInt(item.account_data) :
									parseInt(item.account_data)
							})
						}
					})
					.catch(err => {
						this.$message.error(err.message)
					})
			},
			handlePageSizeChange(num) {
				this.pointInfo.page_size = num
				this.getpointList()
			},
			handleCurrentPageChange(page) {
				this.pointInfo.page = page
				this.getpointList()
			}
		}
	}
